import { tran } from '../../../../translations/schema/TranslationSchema.ts';

export const TableInputWidgetTranslationSchema = tran.widget({
  label: tran.rte(),
  rows: tran.array(
    tran.object({
      label: tran.rte(),
      // Supportiamo in questo modo anche le righe personalizzate.
      // Per le righe normali, `cells` è vuoto e quindi semplicemente
      // non viene processato.
      cells: tran.array(
        tran.object({
          // `tran.widget()` senza una shape permette di effettuare
          // la ricorsione.
          widget: tran.widget(),
        }),
      ),
    }),
  ),
  columns: tran.array(tran.widget()),
});
